module.exports = __webpack_public_path__ + "img/breadcrumb.ba89e4ee.svg";